<script>
  const isTest = false;
  const accountUrl = isTest ? 'http://localhost:8088':'https://remoteserver.storkhealthcare.cn';
  const yunyingUrl = isTest ? 'http://localhost':'https://yunying.server.storkhealthcare.cn';

  export default {
    accountUrl,
    yunyingUrl
  }
</script>



// WEBPACK FOOTER //
// src/components/Global.vue